import React, { Fragment, PureComponent } from 'react';
import { Table } from 'reactstrap';
import FormatNumber from '../FormatNumber';
import { Spacer } from '../Shimmer';
import { changeTypeLabel } from '../utils';

const typeActionMap = {
  accessories: 'ACCESSORY',
  appliances: 'APPLIANCE',
  services: 'SERVICES',
  furnitures: 'FURNITURE',
};

const typeNameMap = {
  accessories: 'product',
  appliances: 'appliance',
  services: 'hdsName',
  furnitures: 'name',
};

export default class GenericTable extends PureComponent {
  // static defaultProps = {
  //   room: {},
  //   type: '',
  //   versions: {},
  // };

  generateOtherRows( // eslint-disable-line class-methods-use-this
    other,
    priceObj,
    firstRow,
    otherRows,
    rowLength,
    type,
    isOther,
  ) {
    return [
      <tr key={other.uid} className={rowLength === 1 ? 'module_end' : null}>
        <td className="vlm" rowSpan={rowLength}>
          <span className="neutral">Updated</span>
        </td>
        <td className="vlm capitalize" rowSpan={rowLength}>
          {isOther ? 'Custom Item' : type}
        </td>
        <td className="vlm" rowSpan={rowLength}>
          {other.name || other[typeNameMap[type]]}
        </td>
        <td className="vlm" rowSpan={rowLength}>
          <FormatNumber number={priceObj.difference} />
        </td>
        {firstRow}
      </tr>,
      otherRows.map((otherRow, index) => (
        <tr
          key={`${other.uid}-row-${index}`} // eslint-disable-line react/no-array-index-key
          className={
            rowLength > 1 && rowLength - 2 === index ? 'module_end' : null
          }
        >
          {otherRow}
        </tr>
      )),
    ];
  }

  generateOtherNestedTemplate(other, type, isOther) {
    const { diff: otherDiff, ...newOther } = other;
    const priceDifference = otherDiff.filter(md => md.type === 'AMOUNT');
    let priceObj;
    if (priceDifference[0]) {
      priceObj = {
        oldAmount: priceDifference[0].oldValue,
        newAmount: priceDifference[0].newValue,
        difference: priceDifference[0].newValue - priceDifference[0].oldValue,
      };
    } else {
      priceObj = {
        oldAmount: 0,
        newAmount: 0,
        difference: 0,
      };
    }

    const changeMap = otherDiff.map(md => (
      <Fragment>
        <td className="vlm">{changeTypeLabel[md.type]}</td>
        <td className="vlm">
          {md.type === 'AMOUNT' ? Math.round(md.oldValue) : md.oldValue}
        </td>
        <td className="vlm">
          {md.type === 'AMOUNT' ? Math.round(md.newValue) : md.newValue}
        </td>
      </Fragment>
    ));

    const changeLength = changeMap.length;
    const [firstRow, ...otherRows] = changeMap;

    const rowTemplate = this.generateOtherRows(
      newOther,
      priceObj,
      firstRow,
      otherRows,
      changeLength,
      type,
      isOther,
    );

    return rowTemplate;
  }

  generateGenericRowsForTable(genericItems, type) {
    const rows = [];

    genericItems.forEach((item) => {
      const { uid } = item;

      if (
        [`OTHER_${typeActionMap[type]}_UPDATED`].indexOf(item.changeType) > -1
      ) {
        rows.push(this.generateOtherNestedTemplate(item, type, true));
      }

      if ([`${typeActionMap[type]}_UPDATED`].indexOf(item.changeType) > -1) {
        console.group(`Generic Updates ==> ${type}`);
        console.log(item);
        console.groupEnd();

        rows.push(this.generateOtherNestedTemplate(item, type, false));
      }

      if (
        [
          `${typeActionMap[type]}_ADDED`,
          `${typeActionMap[type]}_DELETED`,
        ].indexOf(item.changeType) > -1
      ) {
        if (type === 'furnitures') {
          // eslint-disable-next-line no-param-reassign
          item.tax = 0; // Added because ul furnitures have to tax
        }
        rows.push(
          <tr key={uid}>
            <td className="vlm">
              {item.changeType.indexOf('_ADDED') > -1 ? (
                <span className="positive">Added</span>
              ) : (
                <span className="negative">Deleted</span>
              )}
            </td>
            <td className="vlm capitalize">{type}</td>
            <td className="vlm">{item.name || item[typeNameMap[type]]}</td>
            <td className="vlm">
              <FormatNumber
                number={
                  item.changeType.indexOf('_ADDED') > -1
                    ? item.price + (item.tax || 0)
                    : -(item.price + (item.tax || 0))
                }
              />
            </td>
            <td />
            <td />
            <td />
          </tr>,
        );
      }

      if (
        [
          `OTHER_${typeActionMap[type]}_ADDED`,
          `OTHER_${typeActionMap[type]}_DELETED`,
        ].indexOf(item.changeType) > -1
      ) {
        rows.push(
          <tr key={uid}>
            <td className="vlm">
              {item.changeType.indexOf('_ADDED') > -1 ? (
                <span className="positive">Added</span>
              ) : (
                <span className="negative">Deleted</span>
              )}
            </td>
            <td className="vlm capitalize">Custom Item</td>
            <td className="vlm">{item.name || item[typeNameMap[type]]}</td>
            <td className="vlm">
              <FormatNumber
                number={
                  item.changeType.indexOf('_ADDED') > -1
                    ? item.price + (item.tax || 0)
                    : -(item.price + (item.tax || 0))
                }
              />
            </td>
            <td />
            <td />
            <td />
          </tr>,
        );
      }
    });

    if (rows.length > 0) {
      return rows;
    }

    return null;
  }

  render() {
    const { room, type, versions } = this.props;
    return (
      <Fragment>
        {room[type]
          && room[type].length > 0 && (
            <Fragment>
              <h3 className="capitalize">{type}</h3>
              <Spacer size={5} />
              <Table>
                <thead>
                  <tr>
                    <th width="10%" scope="col">
                      Action
                    </th>
                    <th width="10%" scope="col">
                      Category
                    </th>
                    <th width="30%" scope="col">
                      Name
                    </th>
                    <th width="10%" scope="col">
                      Price diff
                    </th>
                    <th width="10%">Change</th>
                    <th width="15%">
Old Value (
                      {`v${versions.versionOld}`}
)
                    </th>
                    <th width="15%">
                      New Value (
                      {`v${versions.versionCurrent}`}
)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.generateGenericRowsForTable(room[type], type)}
                </tbody>
              </Table>
            </Fragment>
        )}
      </Fragment>
    );
  }
}

// GenericTable.propTypes = {
//   room: PropTypes.object,
//   type: PropTypes.string,
//   versions: PropTypes.object,
// };



// WEBPACK FOOTER //
// ./src/components/ComparisionTable/GenericTable.js